import React, { lazy, Suspense } from 'react';

const Keyboard = lazy(() => import('react-simple-keyboard'));

const LazyKeyboard = (props) => (
  <Suspense fallback={null}>
    <Keyboard {...props} />
  </Suspense>
);

export default LazyKeyboard;
